export interface GetTermsRequest {
    /** 任务ID */
    task_id: string;
}

export interface GetTermsTerm {
    unique_id: string;
    name: string;
    annotated: boolean;
    number: string;
}

export interface GetTermsResponse {
    terms: GetTermsTerm[];
}

export const GetTermsApi = Symbol.for('GetTermsApi');

export interface GetTermsApi {
    getTerms(data: GetTermsRequest): Promise<GetTermsResponse>;
}
